<script setup lang="ts">
import { VBadge } from '@/modules/shared/components'
import { useProductStore } from '../stores/product-store'
import { to_currency } from '../utils'

const productStore = useProductStore()

const props = defineProps<{
  invoice: any
  lineItem: any
}>()

const getProductName = () => {
  const priceId = props.lineItem.price?.id
  if (priceId && productStore.prices[priceId]) {
    const price = productStore.prices[priceId]
    const product = productStore.products[price.stripe_product_id]
    return product?.name || props.lineItem.description || 'Product'
  }
  return props.lineItem.description || 'Product'
}

const getAmount = () => {
  return props.lineItem.amount || 0
}

const getCurrency = () => {
  return (props.lineItem.currency || 'usd').toUpperCase()
}

const getStatusColor = () => {
  switch (props.invoice.stripe_cache?.status) {
    case 'paid':
      return 'green'
    case 'open':
      return 'yellow'
    case 'void':
      return 'gray'
    case 'uncollectible':
      return 'red'
    default:
      return 'gray'
  }
}
</script>

<template>
  <div class="flex items-center justify-start space-x-3">
    <aside>
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
        <svg class="h-5 w-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </div>
    </aside>
    <div>
      <div class="flex items-center space-x-3">
        <h1 class="mb-0 flex items-center text-xl text-gray-800">
          {{ getProductName() }}
        </h1>
        <VBadge :color="getStatusColor()" size="xxs">{{ invoice.stripe_cache?.status || 'pending' }}</VBadge>
      </div>
      <div class="mb-0 items-center md:flex md:space-x-2">
        <div>
          {{ to_currency(getAmount(), getCurrency()) }}
          {{ getCurrency() }} / one-time
        </div>
      </div>
    </div>
  </div>
</template>
